import React, { Component } from "react";
import Slider from "react-slick";
import {Link} from 'react-router-dom'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import './style.css'


class SimpleSlider extends Component {
    render() {
      var settings = {
        dots: false,
        arrows: true,
        speed: 1200,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay:true,
        autoplaySpeed:2500,
        fade:true
      };
      return (
        <section className="hero hero-slider-wrapper hero-style-1">
            <div className="hero-slider">
            <Slider {...settings}>
                <div className="slide1 slide">
                    <div className="container">
                        <div className="row">
                            <div className="col col-lg-9 slide-caption">
                                <h2><span>Boardgame and </span>
                                <span>RPG Industry Fulfillment</span></h2>        
                                <div className="btns">
                                    <div className="btn-style"><Link to="/">Start Now</Link></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="slide2 slide">
                    <div className="container">
                        <div className="row">
                            <div className="col col-lg-9 slide-caption">
                                <h2><span>e-Commerce</span> <span>Fulfillment</span></h2>
                                <div className="btns">
                                    <div className="btn-style"><Link to="/">Start Today</Link></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="slide3 slide">
                    <div className="container">
                        <div className="row">
                            <div className="col col-lg-9 slide-caption">
                                <h2><span>Kickstarter</span> <span>Fulfillment</span></h2>
                                <div className="btns">
                                    <div className="btn-style"><Link to="/">Apply Now</Link></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="slide4 slide">
                    <div className="container">
                        <div className="row">
                            <div className="col col-lg-9 slide-caption">
                                <h2><span>Distribution</span><span>Fulfillment</span></h2>
                                <div className="btns">
                                    <div className="btn-style"><Link to="/">Begin Today</Link></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </Slider>
            </div>
        </section>
      );
    }
  }

export default SimpleSlider;